import { Component, ViewChild, inject } from "@angular/core";
import { FormularGroupTabContentComponent } from "../tab-content.interface";
import { CommonKeys } from "../../../formular-model/common/enums";
import { FormularGroupZeiterfassungTableComponent } from "./table/table.component";
import { ItemRequest, ItemResult } from "./zeiterfassung.types";
import {
  FORMULAR_GROUP_ZEITERFASSUNG_TYPE,
  ZEITERFASSUNGEN_TYPE,
} from "../../../formular-model/common/formular-group-types";
import { FormularGroupZeiterfassung } from "../../../formular-model/formular-groups/interfaces/FormularGroupZeiterfassung";
import { CstResponsivePopupService } from "src/app/common-components/resp-popup/services/resp-popup.service";
import { NewOrEditZeiterfassungPopupComponent } from "./popup/popup";

@Component({
  selector: "tab-formular-group-zeiterfassung",
  templateUrl: "./zeiterfassung.component.html",
  styleUrls: ["./zeiterfassung.component.scss"],
  standalone: false,
})
export class FormularGroupTabZeiterfassungComponent extends FormularGroupTabContentComponent<FormularGroupZeiterfassung> {
  override formularGroupDataKey = "Zeiterfassungen";

  private _popup = inject(CstResponsivePopupService);

  @ViewChild("table") table!: FormularGroupZeiterfassungTableComponent;

  get zeiterfassungen() {
    return this.data[this.formularGroupDataKey][CommonKeys.Values];
  }

  public reconstructData(): FormularGroupZeiterfassung {
    return {
      [CommonKeys.Type]: FORMULAR_GROUP_ZEITERFASSUNG_TYPE,
      [CommonKeys.ID]: this.data[CommonKeys.ID],
      [CommonKeys.Label]: this.data[CommonKeys.Label],
      [CommonKeys.ShowLabel]: this.data[CommonKeys.ShowLabel],
      Zeiterfassungen: {
        [CommonKeys.Type]: ZEITERFASSUNGEN_TYPE,
        [CommonKeys.Values]: this.zeiterfassungen,
      },
    };
  }

  onAddItem() {
    const dialogRef = this._popup.open<
      NewOrEditZeiterfassungPopupComponent,
      ItemRequest,
      ItemResult
    >(NewOrEditZeiterfassungPopupComponent, {
      data: {
        state: "new",
        data: null,
      },
    });

    return dialogRef.afterClosed().subscribe({
      next: (result) => this._handleAddItem(result as ItemResult),
      error: (error) => console.error(error),
    });
  }

  private _handleAddItem(itemResult: ItemResult) {
    if (!itemResult || !itemResult.state || !itemResult.data) return;

    this.zeiterfassungen.push(itemResult.data);
    this.table.refresh();
  }
}
